// Reine Payload-Logik fuer Einteilungen. Das optionale Aushilfe-Feld muss
// zwischen "nicht aendern" (nicht vorhanden) und "anonym" (null) unterscheiden.

const normalizeAushilfeUserId = (value) => value || null;

const hasAushilfeUserChanged = (existingData, aushilfeUserId) => (
  (existingData?.aushilfe_user_id || '') !== (aushilfeUserId || '')
);

const getSpringerForAssignment = (funktionKuerzel, springerOverride, existingSpringer = []) => {
  if (funktionKuerzel === 'ZUS') return [];
  const springer = springerOverride !== null ? springerOverride : existingSpringer;
  return (springer || []).map(sf => ({
    fahrzeug_id: sf.fahrzeug_id,
    funktion_kuerzel: sf.funktion_kuerzel,
  }));
};

const buildExistingAushilfeUpdate = ({
  existingData,
  mitarbeiterId,
  datum,
  dienstArt,
  aushilfeUserId,
  istPraktikant,
}) => ({
  type: 'funktion_mit_springer',
  mitarbeiter_id: mitarbeiterId,
  datum,
  dienst_art: dienstArt,
  fahrzeug_id: existingData.hauptfunktion.fahrzeug_id,
  funktion_kuerzel: existingData.hauptfunktion.funktion_kuerzel,
  springer_funktionen: (existingData.sprungfunktionen || []).map(sf => ({
    fahrzeug_id: sf.fahrzeug_id,
    funktion_kuerzel: sf.funktion_kuerzel,
  })),
  ist_praktikant: !!istPraktikant,
  aushilfe_user_id: normalizeAushilfeUserId(aushilfeUserId),
});

const buildFunktionMitSpringerApiPayload = (assignment, abteilungId) => {
  const payload = {
    mitarbeiter_id: assignment.mitarbeiter_id,
    datum: assignment.datum,
    dienst_art: assignment.dienst_art,
    fahrzeug_id: assignment.fahrzeug_id,
    funktion_kuerzel: assignment.funktion_kuerzel,
    springer_funktionen: assignment.springer_funktionen || [],
    ist_praktikant: !!assignment.ist_praktikant,
    abteilung_id: abteilungId,
  };

  if (Object.prototype.hasOwnProperty.call(assignment, 'aushilfe_user_id')) {
    payload.aushilfe_user_id = normalizeAushilfeUserId(assignment.aushilfe_user_id);
  }

  return payload;
};

module.exports = {
  hasAushilfeUserChanged,
  getSpringerForAssignment,
  buildExistingAushilfeUpdate,
  buildFunktionMitSpringerApiPayload,
};
